import { useMemo } from "react";
import {
  getConstructorPitchViewImage,
  getDriverPitchViewImage,
} from "../../../Common/utils/cloudinary";
import useCloudinaryData from "../../../Common/hooks/useCloudinaryData";
import Media from "../../media";

const PitchViewImage = ({ player }) => {
  const { configData, currentSeasonYear } = useCloudinaryData();

  const playerImage = useMemo(() => {
    if (player?.PositionName === "DRIVER") {
      return getDriverPitchViewImage(player, currentSeasonYear, configData);
    } else if (player?.PositionName === "CONSTRUCTOR") {
      return getConstructorPitchViewImage(
        player,
        currentSeasonYear,
        configData
      );
    } else {
      return null;
    }
  }, [configData, currentSeasonYear, player]);

  return (
    <Media imgSrc={playerImage} imgAlt={player?.FUllName} />
    // <img
    //   src={playerImage}
    //   alt={player?.FUllName}
    //   onError={({ currentTarget }) => {
    //     currentTarget.onerror = null; // prevents looping
    //     currentTarget.src = `${CLOUDINARY_IMAGE_BASE_URL}common/fallback.svg?v=${IMAGE_VERSION}`;
    //   }}
    //   loading="lazy"
    // />
  );
};

export default PitchViewImage;
